import { getRootDomain } from '@hpfe/common-base';
import Cookies, { CookieAttributes } from 'js-cookie';

const domain = getRootDomain(window.location.hostname);

const cookieOptions: CookieAttributes = {
  domain,
  path: '/',
};
export const domainCookie = {
  set(key: string, value: string) {
    Cookies.set(key, value, {
      ...cookieOptions,
    });
  },

  get(key: string) {
    return Cookies.get(key);
  },

  remove(key: string) {
    Cookies.remove(key, {
      ...cookieOptions,
    });
  },
};
